export default __webpack_public_path__ + "static/media/logo_caption@2x.8b7ba5e0.png";